import 'normalize.css'
import '../polyfills'

import React, {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {BrowserRouter} from 'react-router-dom'
import {StyleSheetManager, ThemeProvider} from 'styled-components'
import '../assets/style.css'
import {defaultTheme} from '../components/library/theme'
import {AnalyticsProvider} from '../lib/analytics/analytics'
import {getAuth} from '../lib/api'
import {AuthProvider} from '../lib/auth'
import {BugsnagErrorBoundary, init as initBugsnag} from '../lib/bugsnag'
import {OrganisationsProvider} from '../lib/organisations'
import {App} from './app'
import {PostMongerProvider} from './postmonger'
import {shouldForwardProp} from '../lib/should-forward-prop'

const RootComponent = () => (
  <StrictMode>
    <BugsnagErrorBoundary>
      <AuthProvider auth={getAuth()}>
        <OrganisationsProvider>
          <AnalyticsProvider>
            <ThemeProvider theme={defaultTheme}>
              <StyleSheetManager shouldForwardProp={shouldForwardProp}>
                <BrowserRouter>
                  <PostMongerProvider>
                    <App />
                  </PostMongerProvider>
                </BrowserRouter>
              </StyleSheetManager>
            </ThemeProvider>
          </AnalyticsProvider>
        </OrganisationsProvider>
      </AuthProvider>
    </BugsnagErrorBoundary>
  </StrictMode>
)

initBugsnag()

const container = document.getElementById('root')

if (container) {
  const root = createRoot(container)
  root.render(<RootComponent />)
} else {
  throw new Error('Could not mount app at root')
}
